import React from "react";

const FileSkeletonCard = ({ count = 6 }) => {
  return (
    <>
      <div className="file-grid">
        {Array.from({ length: count }).map((_, index) => (
          <div className="file-card" key={index}>
            <div className="file-icon">
              <div
                className="skeleton skeleton-avatar"
                style={{ width: "4rem", height: "4rem", margin: "0.5rem auto" }}
              />
            </div>

            <p className="file-name">
              <div
                className="skeleton skeleton-text"
                style={{ width: "6rem", height: "1rem", margin: "0.5rem auto" }}
              />
            </p>

            <ul className="tags-list">
              <li>
                <div className="skeleton skeleton-text" style={{ width: "3rem", height: "0.8rem", margin: "0.2rem" }} />
              </li>
              <li>
                <div className="skeleton skeleton-text" style={{ width: "3rem", height: "0.8rem", margin: "0.2rem" }} />
              </li>
            </ul>
          </div>
        ))}
      </div>
    </>
  );
};

export default FileSkeletonCard;
